import { FC, useState } from "react"
import { Button } from "@mui/material"
import { enqueueSnackbar } from "notistack"
import { Modal } from "@/core/components"
import { getApiErrorMessage } from "@/core/utils"
import { StaffSchedule } from "../../interfaces"
import {
  useCreateShiftTypeMutation,
  useUpdateShiftTypeMutation,
} from "../../store"
import { ShiftTypeForm, ShiftTypeFormValues } from "./shiftTypeForm"

const FORM_ID = "shift-type-form"

interface ShiftTypeModalProps {
  open: boolean
  editing?: StaffSchedule.ShiftType | null
  onClose: () => void
}

export const ShiftTypeModal: FC<ShiftTypeModalProps> = ({
  open,
  editing,
  onClose,
}) => {
  const [createShiftType] = useCreateShiftTypeMutation()
  const [updateShiftType] = useUpdateShiftTypeMutation()
  const [submitting, setSubmitting] = useState(false)

  // Исход мутации читаем через .unwrap(): промис триггера RTK при ошибке не реджектится.
  const handleSubmit = async (values: ShiftTypeFormValues) => {
    setSubmitting(true)
    try {
      if (editing) {
        await updateShiftType({ id: editing.id, body: values }).unwrap()
      } else {
        await createShiftType(values).unwrap()
      }
      enqueueSnackbar(editing ? "Тип смены обновлён" : "Тип смены создан", {
        variant: "success",
      })
      onClose()
    } catch (e) {
      enqueueSnackbar(getApiErrorMessage(e), { variant: "error" })
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <Modal
      title={editing ? "Редактировать тип смены" : "Новый тип смены"}
      open={open}
      onClose={onClose}
      actions={[
        <Button key="cancel" onClick={onClose} disabled={submitting}>
          Отмена
        </Button>,
        <Button
          key="submit"
          type="submit"
          form={FORM_ID}
          variant="contained"
          disabled={submitting}
        >
          {editing ? "Сохранить" : "Создать"}
        </Button>,
      ]}
    >
      <ShiftTypeForm
        editing={editing}
        onSubmit={handleSubmit}
        formId={FORM_ID}
      />
    </Modal>
  )
}
